/**
 * Article Gallery Lightbox
 * Self-scoped lightbox: each `[data-article-gallery]` container has its
 * own `[data-article-lightbox]`. Multiple galleries on the same page are
 * supported. Triggers, navigation, keyboard and swipe are all wired
 * within the gallery scope.
 */
(function () {
  'use strict';

  function initGallery(gallery) {
    var lightbox = gallery.querySelector('[data-article-lightbox]');
    if (!lightbox || lightbox.dataset.articleLightboxReady === '1') return;
    lightbox.dataset.articleLightboxReady = '1';

    var slides = lightbox.querySelectorAll('[data-article-lightbox-slide]');
    var totalSlides = slides.length;
    var currentEl = lightbox.querySelector('[data-article-lightbox-current]');
    var currentIndex = 0;
    var isOpen = false;

    function showSlide(index) {
      slides.forEach(function (s) { s.classList.remove('is-active'); });
      if (slides[index]) slides[index].classList.add('is-active');
      if (currentEl) currentEl.textContent = index + 1;
    }

    function open(index) {
      currentIndex = index;
      showSlide(currentIndex);
      lightbox.setAttribute('aria-hidden', 'false');
      document.body.style.overflow = 'hidden';
      isOpen = true;
    }

    function close() {
      lightbox.setAttribute('aria-hidden', 'true');
      document.body.style.overflow = '';
      isOpen = false;
    }

    function next() {
      if (totalSlides === 0) return;
      currentIndex = (currentIndex + 1) % totalSlides;
      showSlide(currentIndex);
    }

    function prev() {
      if (totalSlides === 0) return;
      currentIndex = (currentIndex - 1 + totalSlides) % totalSlides;
      showSlide(currentIndex);
    }

    /* Open triggers (within this gallery scope only) */
    gallery.querySelectorAll('[data-article-lightbox-open]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var index = parseInt(btn.getAttribute('data-article-lightbox-index'), 10) || 0;
        open(index);
      });
    });

    /* Close triggers */
    lightbox.querySelectorAll('[data-article-lightbox-close]').forEach(function (btn) {
      btn.addEventListener('click', close);
    });

    /* Prev / Next */
    lightbox.querySelectorAll('[data-article-lightbox-prev]').forEach(function (btn) {
      btn.addEventListener('click', prev);
    });
    lightbox.querySelectorAll('[data-article-lightbox-next]').forEach(function (btn) {
      btn.addEventListener('click', next);
    });

    /* Keyboard */
    document.addEventListener('keydown', function (e) {
      if (!isOpen) return;
      if (e.key === 'Escape') close();
      if (e.key === 'ArrowLeft') prev();
      if (e.key === 'ArrowRight') next();
    });

    /* Swipe */
    var touchStartX = 0;
    var touchEndX = 0;
    lightbox.addEventListener('touchstart', function (e) {
      touchStartX = e.changedTouches[0].screenX;
    }, { passive: true });
    lightbox.addEventListener('touchend', function (e) {
      touchEndX = e.changedTouches[0].screenX;
      var diff = touchStartX - touchEndX;
      if (Math.abs(diff) > 50) {
        if (diff > 0) next(); else prev();
      }
    }, { passive: true });
  }

  function bootstrap() {
    document.querySelectorAll('[data-article-gallery]').forEach(initGallery);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', bootstrap);
  } else {
    bootstrap();
  }
})();
